import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: {
        id: string
    }
}

const { onRequest, onSuccess, onFailure } = rootActions.products.productStaticEnums
function* productStaticEnumsSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/products/static-enums`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* productStaticEnumsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, productStaticEnumsSagaTask)
}

export default productStaticEnumsSaga
